import {COUNTRY} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';

export const authorizationObject = {
    [COUNTRY]: SECURITY_PRIVILEGES_READ,
};
